import isEqual from "lodash-es/isEqual";

import FilterModel, {
  CombinedCondition,
  FilterCondition,
  SimpleCondition,
} from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isCombinedCondition } from "./assert";

export const areSimpleConditionsEqual = (a: SimpleCondition, b: SimpleCondition): boolean => {
  if (a.operator !== b.operator || Array.isArray(a.value) !== Array.isArray(b.value)) {
    return false;
  }
  return Array.isArray(a.value) && Array.isArray(b.value)
    ? isEqual([...a.value].sort(), [...b.value].sort()) // compare values in any order
    : isEqual(a.value, b.value);
};

export const areCombinedConditionsEqual = (a: CombinedCondition, b: CombinedCondition): boolean => {
  return (
    a.operator === b.operator &&
    a.conditions.length === b.conditions.length &&
    a.conditions.every((aCondition, index) => areConditionsEqual(aCondition, b.conditions[index]))
  );
};

export const areConditionsEqual = (a: FilterCondition, b: FilterCondition): boolean => {
  const isACombined = isCombinedCondition(a);
  const isBCombined = isCombinedCondition(b);

  if (isACombined !== isBCombined) {
    return false;
  }

  // enough to check only one
  if (isACombined) {
    return areCombinedConditionsEqual(a as CombinedCondition, b as CombinedCondition);
  } else {
    return areSimpleConditionsEqual(a as SimpleCondition, b as SimpleCondition);
  }
};

export const areFiltersEqual = (a: FilterModel, b: FilterModel): boolean => {
  const aFieldFilterNames = Object.keys(a);
  const bFieldFilterNames = Object.keys(b);

  if (aFieldFilterNames.length !== bFieldFilterNames.length) {
    return false;
  }

  return aFieldFilterNames.every(
    (fieldFilterName) =>
      // we need to check if both A and B have this field because previous length check only
      // ensured that the number of fields is equal, although the set of fields can still be different
      a[fieldFilterName] &&
      b[fieldFilterName] &&
      areConditionsEqual(a[fieldFilterName], b[fieldFilterName])
  );
};
